import React from "react";
import StyledSelect from "../../components/StyledSelect";
import { styles } from "./leadsStyles";

export function LeadsGoogleCalendarTab({ vm }) {
  const {
    googleCalendarMessage,
    googleCalendarStatus,
    googleCalendarConnected,
    googleCalendarEmail,
    googleCalendarId,
    setGoogleCalendarId,
    googleCalendarCalendars,
    googleCalendarTimezone,
    setGoogleCalendarTimezone,
    googleCalendarStartHour,
    setGoogleCalendarStartHour,
    googleCalendarEndHour,
    setGoogleCalendarEndHour,
    googleCalendarEnabled,
    setGoogleCalendarEnabled,
    connectGoogleCalendar,
    saveGoogleCalendarConfig,
    testGoogleCalendar,
    createGoogleCalendarTestEvent,
    removeGoogleCalendarConfig,
  } = vm;
  return (
              <div style={styles.webhookContainer}>
                <h3 style={styles.sectionTitle}>Integração com Google Agenda</h3>
                <p style={styles.webhookDescription}>
                  Conecte a conta Google do cliente para permitir criação de eventos de agendamento direto pelo bot.
                </p>

                {googleCalendarMessage && (
                  <div style={{
                    ...styles.message,
                    ...(googleCalendarStatus === "success" ? styles.messageSuccess : styles.messageError)
                  }}>
                    {googleCalendarMessage}
                  </div>
                )}

                <div style={styles.formGroup}>
                  <label style={styles.label}>Status da conexão:</label>
                  <p style={styles.helperText}>
                    {googleCalendarConnected ? "Conectado" : "Não conectado"}
                    {googleCalendarEmail ? ` (${googleCalendarEmail})` : ""}
                  </p>
                </div>

                <div style={styles.formGroup}>
                  <label style={styles.label}>Calendário:</label>
                  <StyledSelect
                    value={googleCalendarId}
                    onChange={setGoogleCalendarId}
                    options={[
                      { value: "primary", label: "primary (padrão)" },
                      ...googleCalendarCalendars.map((c) => ({
                        value: c.id,
                        label: c.primary ? `${c.summary} (primary)` : c.summary
                      }))
                    ]}
                    placeholder="Selecione o calendário"
                  />
                </div>

                <div style={styles.formGroup}>
                  <label style={styles.label}>Timezone:</label>
                  <input
                    type="text"
                    value={googleCalendarTimezone}
                    onChange={(e) => setGoogleCalendarTimezone(e.target.value)}
                    placeholder="America/Sao_Paulo"
                    style={styles.input}
                  />
                </div>

                <div style={styles.formGroup}>
                  <label style={styles.label}>Hora início (horário comercial):</label>
                  <input
                    type="number"
                    min={0}
                    max={23}
                    value={googleCalendarStartHour}
                    onChange={(e) => setGoogleCalendarStartHour(Number(e.target.value) || 0)}
                    style={styles.input}
                  />
                  <span style={styles.helperText}>Ex.: 9 para 09:00</span>
                </div>

                <div style={styles.formGroup}>
                  <label style={styles.label}>Hora fim (horário comercial):</label>
                  <input
                    type="number"
                    min={1}
                    max={24}
                    value={googleCalendarEndHour}
                    onChange={(e) => setGoogleCalendarEndHour(Number(e.target.value) || 18)}
                    style={styles.input}
                  />
                  <span style={styles.helperText}>Ex.: 17 para 17:00 (reuniões até 16:59)</span>
                </div>

                <div style={styles.formGroup}>
                  <label style={styles.label}>Integração ativa:</label>
                  <StyledSelect
                    value={googleCalendarEnabled ? "enabled" : "disabled"}
                    onChange={(v) => setGoogleCalendarEnabled(v === "enabled")}
                    options={[
                      { value: "enabled", label: "Ativada" },
                      { value: "disabled", label: "Desativada" }
                    ]}
                    placeholder="Status"
                  />
                </div>

                <div style={styles.buttonGroup}>
                  <button onClick={connectGoogleCalendar} style={styles.button}>
                    Conectar com Google
                  </button>
                  <button onClick={saveGoogleCalendarConfig} style={styles.buttonSecondary}>
                    Salvar Configuração
                  </button>
                  <button onClick={testGoogleCalendar} style={styles.buttonSecondary}>
                    Testar Conexão
                  </button>
                  <button onClick={createGoogleCalendarTestEvent} style={styles.buttonSecondary}>
                    Criar Evento de Teste
                  </button>
                  <button onClick={removeGoogleCalendarConfig} style={styles.buttonDanger}>
                    Excluir integração
                  </button>
                </div>
              </div>
  );
}
